export default __webpack_public_path__ + "static/media/repair_finished.6b0b6ab8.png";